import {
  SALARYLIST_ALL,
  SALARYLIST_GET,
  SALARYLIST_DEL,
  SALARYLIST_PUT,
  SALARYLIST_POST,
  SALARYLIST_LOADING,
  SALARYLIST_ERROR,
  SALARYLIST_RESET,
  SALARY_DETAIL_GET,
  SALARY_DETAIL_ERROR,
  SALARY_DETAIL_RESET,
} from '../types';

import api from '../../../utils/functions/api';

export const salaryListCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SALARYLIST_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/salary-list`,
      payload,
    );
    dispatch({ type: SALARYLIST_POST, payload: data });
    return data;
  } catch (error) {
    const msg = error?.response?.data?.error?.message || error?.message || String(error);
    console.error('[salaryListCreate] status:', error?.response?.status, '| message:', msg);
    dispatch({ type: SALARYLIST_ERROR });
    throw new Error(msg);
  }
};

export const salaryListCheckPeriod = ({ dateStart, dateEnd, role_type = '' }) => async () => {
  const { data } = await api.get(
    `${process.env.REACT_APP_API_URL}/salary-list/check-period?dateStart=${dateStart}&dateEnd=${dateEnd}&role_type=${role_type}`,
  );
  return data;
};

export const salaryListAll = (params) => async (dispatch) => {
  try {
    dispatch({ type: SALARYLIST_LOADING });
    const { name = '', size = 200, page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/salary-list?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: SALARYLIST_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: SALARYLIST_ERROR });
    throw new Error(error);
  }
};

export const salaryListGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/salary-list/${id}`,
    );
    if (status === 200) {
      dispatch({ type: SALARYLIST_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: SALARYLIST_ERROR });
    throw new Error(error);
  }
};

// เหมือน salaryListGet เป๊ะๆ แต่เก็บผลลง state.salaryDetail แยกต่างหาก — ใช้จุดที่ต้องดู
// เงินเดือน "1 รายการ" (HrSalaryDetail, เช็คสถานะล็อกงวดใน HrReportV2) โดยไม่ไปทับ
// state.salaryList (rows ของหน้ารายการทั้งหมด ที่ HrSalaryList/SalaryListTable ใช้อยู่)
export const salaryDetailGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/salary-list/${id}`,
    );
    if (status === 200) {
      dispatch({ type: SALARY_DETAIL_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: SALARY_DETAIL_ERROR });
    throw new Error(error);
  }
};

export const salaryDetailReset = () => async (dispatch) => {
  dispatch({ type: SALARY_DETAIL_RESET });
};

export const salaryListPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: SALARYLIST_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/salary-list/${id}`,
      payload,
    );
    dispatch({ type: SALARYLIST_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: SALARYLIST_ERROR });
    throw new Error(error);
  }
};
export const salaryListDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: SALARYLIST_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/salary-list/${id}`,
    );
    dispatch({ type: SALARYLIST_DEL, payload: data });
    // { deletedLaborCount, preparedWarning: [code...] } — ผู้เรียกเอาไปเตือนผู้ใช้ถ้ามีรายการ PREPARE ค้าง
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: SALARYLIST_ERROR });
    throw new Error(error);
  }
};

export const salaryListReset = () => async (dispatch) => {
  try {
    dispatch({ type: SALARYLIST_RESET });
  } catch (error) {
    console.error(error);
    dispatch({ type: SALARYLIST_ERROR });
    throw new Error(error);
  }
};
